// extracted by mini-css-extract-plugin
export var randomContainer = "index-module--randomContainer--mUYvl";
export var avatarContainer = "index-module--avatarContainer--oOytq";
export var avatarSelector = "index-module--avatarSelector--OdMG2";
export var avatar = "index-module--avatar--EvCv7";